export default function () {
	return Tools.FeatureHelper.hasSoftDeployAccess('REACT_CLIENT_CARD');
}
